// src/views/source-connections/components/wizard/StepSelectSource.jsx

import React from "react";
import { getSourcesByCategory } from "../../sourceTypes";
import SourceTypeCard from "../SourceTypeCard";

const StepSelectSource = ({ selectedType, onSelect }) => {
  const categories = getSourcesByCategory();

  return (
    <div className="px-7 py-6 overflow-y-auto" style={{ maxHeight: "68vh" }}>
      {categories.map((cat, catIdx) => (
        <div key={cat.id} className={catIdx > 0 ? "mt-6" : ""}>
          <div className="flex items-center gap-3 mb-3.5">
            <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-text-2 whitespace-nowrap">
              {cat.label}
            </span>
            <div className="flex-1 h-px bg-border" />
          </div>
          <div className="grid grid-cols-3 gap-4">
            {cat.sources.map((source) => (
              <SourceTypeCard
                key={source.id}
                sourceType={source}
                selected={selectedType?.id === source.id}
                onSelect={onSelect}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepSelectSource;
